import moment from 'moment';

// Utility function to format date based on the conditions
const formatDate = (date) => {
  const today = moment();
  const yesterday = moment().subtract(1, 'days');
  
  // Check if it's today
  if (moment(date).isSame(today, 'day')) {
    return "Today";
  }
  // Check if it's yesterday
  if (moment(date).isSame(yesterday, 'day')) {
    return "Yesterday";
  }
  // Check if it's within the current week
  if (moment(date).isSame(today, 'week')) {
    return moment(date).format('dddd');
  }
  // Otherwise, return the formatted date
  return moment(date).format("DD-MM-YYYY");
};

export default formatDate;
